module.exports = __webpack_public_path__ + "static/media/candle.a20234a4.webp";